import React, { useState, useEffect, Fragment } from "react";
import { Grid, Typography, CircularProgress, Paper, makeStyles } from "@material-ui/core";
// import Axios from "axios";
// import Cookies from "js-cookie";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { selectUser, setUser } from "../../features/data/user/userSlice";

const useStyles = makeStyles((theme) => ({
  titleTypo: {
    marginTop: 10,
    marginBottom: 20,
    fontSize: 30,
    fontWeight: 800,
  },
  nameTypo: {
    fontWeight: "bold",
    fontSize: 15,
  },
  valueTypo: {
    fontSize: 15,
    // color: "#424242",
    marginLeft: 5,
  },
  itemGrid: {
    marginTop: 15,
  },
}));

const Profile = (props) => {
  const classes = useStyles();

  const { user } = useSelector(selectUser, shallowEqual);

  return (
    <Grid container direction='column' style={{ padding: 10 }}>
      <Typography className={classes.titleTypo}>حساب کاربری</Typography>

      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <Paper style={{ padding: 10 }}>
            <Typography variant='h6' style={{ fontWeight: "bold" }}>
              اطلاعات شخصی
            </Typography>
            {!user ? (
              <CircularProgress style={{ color: "#757575" }} />
            ) : (
              <Fragment>
                <Grid
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  className={classes.itemGrid}
                >
                  <Typography className={classes.nameTypo}>نام:</Typography>
                  <Typography className={classes.valueTypo} color='textSecondary'>
                    {user.first_name?.toString()?.toPersianDigits()}
                  </Typography>
                </Grid>
                <Grid
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  className={classes.itemGrid}
                >
                  <Typography className={classes.nameTypo}>نام خانوادگی:</Typography>
                  <Typography className={classes.valueTypo} color='textSecondary'>
                    {user.last_name?.toString()?.toPersianDigits()}
                  </Typography>
                </Grid>
                <Grid
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  className={classes.itemGrid}
                >
                  <Typography className={classes.nameTypo}>شماره تماس:</Typography>
                  <Typography className={classes.valueTypo} color='textSecondary'>
                    {user.phone_number?.toString()?.toPersianDigits()}
                  </Typography>
                </Grid>
              </Fragment>
            )}
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper style={{ padding: 10 }}>
            <Typography variant='h6' style={{ fontWeight: "bold", flexGrow: 1 }}>
              اطلاعات مشاور املاک
            </Typography>

            {!user ? (
              <CircularProgress style={{ color: "#757575" }} />
            ) : (
              <Fragment>
                <Grid
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  className={classes.itemGrid}
                >
                  <Typography className={classes.nameTypo}>عنوان:</Typography>
                  <Typography className={classes.valueTypo} color='textSecondary'>
                    {user.work_title?.toString()?.toPersianDigits()}
                  </Typography>
                </Grid>

                <Grid
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  className={classes.itemGrid}
                >
                  <Typography className={classes.nameTypo}>شماره ثابت:</Typography>
                  <Typography className={classes.valueTypo} color='textSecondary'>
                    {user.work_number?.toString()?.toPersianDigits()}
                  </Typography>
                </Grid>

                <Grid
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  className={classes.itemGrid}
                >
                  <Typography className={classes.nameTypo}>آدرس:</Typography>
                  <Typography className={classes.valueTypo} color='textSecondary'>
                    {user.work_address?.toString()?.toPersianDigits()}
                  </Typography>
                </Grid>
              </Fragment>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Profile;
